import { render, staticRenderFns } from "./uf_result_natural.vue?vue&type=template&id=adc3427e&scoped=true"
import script from "./uf_result_natural.vue?vue&type=script&lang=js"
export * from "./uf_result_natural.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc3427e",
  null
  
)

export default component.exports